import history from 'app/history';
import isBackOffice from 'utils/appUtils';

export const navToVXValueLocation = (path) => {
  if (isBackOffice) {
    if (window.location.hostname !== 'localhost') {
      window.location.href = path;
    }
  }
};

export const navtoLogin = () => {
  navToVXValueLocation('/vxvalue/faces/SignIn.jsp');
};

export const navToOrders = () => {
  navToVXValueLocation('/vxvalue/faces/MyOrders.jsp');
};

export const navToLogout = () => {
  navToVXValueLocation('/vxvalue/faces/Logout.jsp');
};

const navigate = (path, ...args) => {
  history.push(path, ...args);
};

export default navigate;
